import * as React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { Stack } from '@fluentui/react/lib/Stack';
import styled from 'styled-components';

const FullHeightStack = styled(Stack)`
  height: 100vh;
`;

export function LoadingSpinner(): React.ReactElement {
  return (
    <FullHeightStack 
      verticalAlign="center" 
      horizontalAlign="center" 
    >
      <Spinner size={SpinnerSize.large} label="Loading..." />
    </FullHeightStack>
  );
}